const translation_table = {
  text_state_scan: "สถิติการสแกนเข้า-ออก",
  text_std_total: "นักเรียนทั้งหมด",
  text_scan_in: "สแกนเข้า",
  text_no_scan: "ไม่สแกน",
  text_scan_out: "สแกนออก",
  text_scan_late: "สาย",
  text_scan_befor: "กลับก่อน",
  press_release: "ข่าวประชาสัมพันธ์",
  system_text: "ระบบงาน",
  menu_text: "เมนู",

  text_check_row: "เช็คแถว",
  text_check_homeroom: "โฮมรูม",
  text_advisee: "นักเรียนที่ปรึกษา",
  text_document: "เอกสารนักเรียน",
  text_behavior: "ความประพฤติ",
  text_visithome: "เยี่ยมบ้าน",
  text_sdq: "SDQ",

  text_check_time: "เช็ครายคาบ",
  text_timetable: "ตารางสอน",
  text_homework: "การบ้าน",
  text_activitie: "กิจกรรมพัฒนาผู้เรียน",
  text_others: "อื่น ๆ",
  text_report: "รายงาน",

  menu_goverment_main: "งานปกครอง",
  menu_academic_main: "งานวิชาการ",
  menu_evoluation_main: "งานวัดผล",
  menu_registration_main: "งานทะเบียน",
  menu_advertise_main: "ประชาสัมพันธ์",
  menu_person_main: "งานบุคลากร",
  menu_medical_main: "ห้องพยาบาล",
  menu_setting_main: "ตั้งค่า",

  ///////////////////////////////////////////////
  text_check_row_homeroom: "เช็คแถว/โฮมรูม",
  text_check_sts_checked: "เช็คแถวแล้ว",
  text_check_sts_notchecked: "ยังไม่เช็คแถว",
  text_check_sts_present: "มาเรียน",
  text_check_sts_absent: "ขาดเรียน",
  text_check_sts_per1: "ร้อยละ",
  text_check_sts_per2: "ของทั้งหมด",
  text_check_sts_per3: "",
  text_check_sts_forgot_card1: "ลืมบัตร",
  text_check_sts_forgot_card2: "คน",
  text_check_date: "วันที่เช็คแถว",
  text_check_classRoom: "ระดับชั้น",
  text_check_ok: "ตกลง",
  text_check_view_report: "ดูรายงาน",
  text_check_no: "เลขที่",
  text_check_student_id: "รหัส",
  text_check_student_name: "ชื่อ-สกุล",
  text_check_time_in: "เวลาเข้า",
  text_check_status: "สถานะ",
  text_check_save: "บันทึก",
  text_check_back: "กลับ",
  text_check_cancel: "ยกเลิก",
  text_check_timeout: "หมดเวลาบันทึกเช็คแถว",
  text_check_not_have_student: " คุณไม่มีข้อมูลนักเรียนในที่ปรึกษา",
  text_check_homeroom_content: "เนื้อหาโฮมรูม",

  ///////////////////////////////////////////////
  text_consult_date: "วันที่",
  text_classRoom: "ระดับชั้น",
  text_view_registration: "ดูทะเบียนประวัติ",
  text_behavior_score: "คะแนนคงเหลือ",
  text_behavior_scan_in: "สแกนเข้า",
  text_behavior_scan_out: "สแกนออก",

  text_home: "หน้าแรก",
  text_sex_man: "ชาย",
  text_sex_woman: "หญิง",

  text_std_have_card: "นักเรียนที่มีบัตร",
  text_std_no_card: "นักเรียนที่ไม่มีบัตร",
  text_image: "รูป",

  text_home_room: "โฮมรูม",
  text_home_room_sum: "สรุปโฮมรูม",

  text_find: "ค้นหา",
  text_or: "หรือ",
  text_stdno: "รหัสนักเรียน",
  text_std: "นักเรียน",
  text_class: "ระดับชั้น",
  text_card_number: "รหัสบัตร",
  text_card: "บัตร",
  text_input_find_std: "รหัส ชื่อ หรือ นามสกุล",
  text_checkrow: "การเช็คแถว",
  text_checkrow_sumary: "การเช็คแถวรายเดือน",
  text_check_act: "เช็คกิจกรรม",
  text_cutscore: "หักคะแนน",
  text_addscore: "เพิ่มคะแนน",
  text_score: "คะแนนความประพฤติ",
  text_scan_sum: "รายงานสรุป",
  text_person_total: "บุคลากรทั้งหมด",

  menu_admission: "ระบบรับสมัคร",
  menu_test: "ระบบทดสอบ",

  menu_goverment_cutaddscore: "หัก/เพิ่ม คะแนน",
  menu_goverment_cutscore: "กลุ่มการหักคะแนน",
  menu_goverment_addscore: "กลุ่มการเพิ่มคะแนน",
  menu_goverment_leave: "ใบลา",
  menu_goverment_scanmanual: "ลงเวลาลืมบัตร",
  menu_goverment_holiday: "จัดการวันหยุด",
  menu_goverment_groupscan: "จัดการกลุ่มสแกน",
  menu_goverment_card: "จัดการบัตรนักเรียน",
  menu_goverment_report_scanin: "การสแกนเข้า",
  menu_goverment_report_scanout: "การสแกนออก",
  menu_goverment_report_scanday: "การสแกนรายวัน",
  menu_goverment_report_scanin_out: "การสแกนเข้า-ออก",

  // 'menu_goverment_report_scanin':'การสแกนเข้า',
  // 'menu_goverment_report_scanin':'การสแกนเข้า',

  menu_registration_studentinfo: "ข้อมูลนักเรียน",
  menu_registration_class: "ข้อมูลระดับชั้น",
  menu_registration_doc: "เอกสาร",
  menu_registration_new_card: "คำร้องทำบัตรใหม่",

  menu_financial_main: "การเงิน",

  menu_person_person: "บุคลากร",
  menu_person_leave: "ใบลา",
  menu_person_depart: "แผนก",
  menu_person_position: "ตำแหน่ง",
  menu_person_userpermission: "กำหนดสิทธิ์การเข้าใช้เมนู",

  menu_library_main: "ห้องสมุด",

  menu_setting: "ตั้งค่า",
  menu_setting_school: "สถานศึกษา",
  menu_setting_termyear: "ตั้งค่าปีการศึกษา",
  menu_setting_user: "กำหนดสิทธิ์",

  menu_teacher_consult_main: "ครูที่ปรึกษา",
  menu_teacher_main: "ครูผู้สอน",

  btn_add_new: "เพิ่มใหม่",
  btn_back: "กลับ",
  btn_save: "บันทึก",
  btn_cancel: "ยกเลิก",
  btn_submit: "ตกลง",
  btn_ok: "ตกลง",
  btn_edit: "แก้ไข",
  btn_map_card: "แม็บบัตร",

  form_ids_text: "",
  form_prefix_text: "",
  form_fname_text: "",
  form_lname_text: "",
  form_stdno_text: "",
  form_birthday_text: "",
  form_mobile_text: "",
  form_email_text: "",
  form_sex_text: "",

  /////////////////////////////////////////////////
  //Parent
  text_parent_dashboard: "ข้อมูลนักเรียน",
  text_parent_dashboard_student: "ข้อมูล",
  text_parent_dashboard_student_stdno: "รหัส",
  text_parent_dashboard_student_timein: "สแกนเข้า",
  text_parent_dashboard_student_timeout: "สแกนออก",
  text_parent_dashboard_student_scorebalance: "คะแนนคงเหลือ",

  // scantime
  text_parent_student_checkrow: "เช็คแถว",
  text_parent_student_scandate: "วันที่สแกน",
  text_parent_student_timein: "เวลาสแกนเข้า",
  text_parent_student_timeout: "เวลาสแกนออก",
  text_parent_student_charttimein: "สถิติสแกนเข้า",
  text_parent_student_charttimeout: "สถิติสแกนออก",

  // scorebalance

  text_parent_student_total: "คะแนนคงเหลือ",
  text_parent_student_totalall: "คะแนนเต็ม",
  text_parent_student_plus: "เพิ่มทั้งหมด",
  text_parent_student_minus: "หักทั้งหมด",
  text_parent_student_date: "วันที่/เวลา",
  text_parent_student_title: "หัวข้อ",
  text_parent_student_score: "คะแนน",
  text_parent_student_by: "โดย",
  text_parent_student_remark: "หมายเหตุ",

  menu_parent_scantime: "ประวัติการสแกน",

  menu_parent_scorebalance: "คะแนนความประพฤติ",

  menu_parent_grade: "ผลการเรียน",

  menu_parent_timetable: "ตารางเรียน",

  menu_parent_SDQ: "SDQ",

  text_check_not_in: "ขาด",
  text_check_in: "มา",

  finance: "การเงิน",
  finance_manage_items: "รายการหนี้",
  finance_manage_items_add: "เพิ่มรายการหนี้",
  finance_manage_items_edit: "แก้ไขรายการหนี้",
  finance_manage_items_delete: "ลบรายการหนี้",
  finance_manage_debt_group: "กลุ่มหนี้",
  finance_manage_debt_group_add: "เพิ่มกลุ่มหนี้",
  finance_manage_debt_group_edit: "แก้ไขกลุ่มหนี้",
  finance_manage_debt_group_delete: "ลบกลุ่มหนี้",
  finance_manage_debt_group_detail: "รายละเอียดกลุ่มหนี้",
  finance_manage_set_debt: "ตั้งหนี้",
  finance_manage_set_debt_add: "เพิ่ม",
  finance_manage_set_debt_edit: "แก้ไข",
  finance_manage_set_debt_delete: "ลบ",

  menu_registration_depart: "แผนการเรียน",
  menu_card: "บัตรนักเรียน",



  //////////// สรรหามาเล่า rotary//////////////

  //สว่น login และ register
  login_title: "เข้าสู่ระบบ",
  login_button: "เข้าสู่ระบบ",
  input_username: "ชื่อผู้ใช้ (Username)",
  span_username: "กรุณากรอกชื่อผู้ใช้",
  input_password: "รหัสผ่าน (Password)",
  span_password: "กรุณากรอกรหัสผ่าน",

  show_password: "แสดง/ซ่อนรหัสผ่าน",
  remamber_me: "จดจำ",

  auth_hero_title: "ร่วมสร้างสิ่งดี ๆ",
  auth_hero_subtitle: "เพื่อชุมชน สังคม และโลก",
  auth_hero_description: "โรตารีคือเครือข่ายของผู้นำและผู้ลงมือทำ ที่ร่วมกันสร้างการเปลี่ยนแปลงอย่างยั่งยืนในชุมชนและทั่วโลก",

  // คู่มือ
  manual_title: "คู่มือการใช้งานระบบ",
  button_close: "ปิด",

  register_title: "สมัครสมาชิก",
  register_button: "สมัครสมาชิก",
  input_name: "ชื่อ",
  span_name: "กรุณากรอกชื่อ",
  input_lastname: "นามสกุล",
  span_lastname: "กรุณากรอกนามสกุล",
  input_confirm_password: "ยืนยันรหัสผ่าน (Confirm Password)",
  span_confirm_password: "กรุณากรอกยืนยันรหัสผ่าน",
  have_account: "มีบัญชีผู้ใช้แล้ว? ",
  not_have_account: "ยังไม่มีบัญชี?",



  //ส่วนหัวสุด
  name_website: "สรรหามาเล่า",
  profile_button: "โปรไฟล์",
  logout_button: "ออกจากระบบ",


  ///////////// ส่วนค้นหาโพส //////////////
  search_placeholder: "ค้นหาผู้เขียน หรือคำที่ต้องการอ่าน",
  search_button: "ค้นหา",
  search_hint: "ค้นหาเฉพาะผู้เขียน หรือกรองโพสต์ในฟีด",
  author: "ผู้เขียน",
  all: "ทั้งหมด",
  filters: "ตัวกรอง:",
  filter_all: "ทั้งหมด",
  filter_following: "เฉพาะผู้เขียนที่ติดตาม",
  filter_saved: "โพสต์ที่บันทึกไว้",
  post_placeholder: "โพสต์",  // ตัวหนังสือ
  post_button: "โพสต์", // ปุ่ม


  ///////////// กล่องส่วนที่สร้างโพส //////////////
  bold: "ตัวหนา",
  italic: "ตัวเอียง",
  underline: "ขีดเส้นใต้",
  link: "เเนบลิงก์",
  image: "เเนบรูปภาพ",
  video: "เเนบวิดีโอ",

  save_button: "บันทึก",
  cancel_button: "ยกเลิก",
  update_button: "อัปเดต",
  close_button: "ปิด",

  title_create_video: "วาง Video URL แล้วกด Enter ก่อนกดโพสต์",
  span_create_video: "รองรับ YouTube / Facebook / TikTok (วางลิงก์แล้วกด Enter)",

  //////////// กล่องโพสและคอมเมนต์ //////////////
  follow_button: "ติดตามผู้เขียน",
  save_post_button: "บันทึกโพสต์",
  edit_post_button: "แก้ไขโพสต์",
  delete_post_button: "ลบโพสต์",

  hide_text: "ซ่อนข้อความ",
  show_text: "ดูเพิ่มเติม",

  reply: "ตอบกลับ",
  cancel: "ยกเลิก",

  send: "ส่ง",
  edit_comment_title: "แก้ไขความคิดเห็น...",
  delete_comment_title: "ลบความคิดเห็น",
  comment_placeholder: "เขียนความคิดเห็น...",

  //////// models แก้ไขรูปภาพ ////////////
  title_edit_image: "แก้ไขภาพอัพโหลด",
  span_edit_image: "ไม่มีข้อมูลรูปภาพอัพโหลด",
  span_edit_image2: "แตะที่รูปเพื่ออัปโหลดรูปโปรไฟล์ใหม่",
  back_profile: "กลับไปหน้าโปรไฟล์",


  //////// แก้ไขข้อมูลส่วนตัว ////////////
  displayname : "ชื่อที่แสดง",
  email: "อีเมล",
  span_email: "กรุณากรอกชอีเมล",
  saving: "กำลังบันทึก...",
  save_success: "บันทึกข้อมูล",
  reset: "รีเซ็ต",
  text_post: "โพสต์",
  text_follower: "ผู้ติดตาม",
  text_following: "กำลังติดตาม",
  text_account: "สมาชิก",
  text_edit_profile: "แก้ไขโปรไฟล์",
  text_edit_cover: "แก้ไขภาพพื้นหลัง",


};
export default translation_table;
